import React from "react";
import ReactDOM from "react-dom";
import { HashRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import thunk from "redux-thunk";

import App from "./App";
import { unregister } from "./registerServiceWorker";
import authReducer from "./store/reducers/auth";
import requestReducer from "./store/reducers/request";
import documentReducer from "./store/reducers/document";
import addressReducer from "./store/reducers/address";
import companyReducer from "./store/reducers/company";
import contactReducer from "./store/reducers/contact";
import sectionReducer from "./store/reducers/section";
import userReducer from "./store/reducers/user";
import * as actionTypes from "./store/actions/actionTypes";

import "../node_modules/font-awesome/css/font-awesome.min.css";
//import "bootstrap/dist/css/bootstrap.min.css";
import "styles/bootstrap.scss";
import "styles/app.scss";
import "styles/theme-a.scss";
import "react-tippy/dist/tippy.css";

import "./index.css";

import reduxReset from "redux-reset";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const appReducer = combineReducers({
  auth: authReducer,
  company: companyReducer,
  request: requestReducer,
  document: documentReducer,
  user: userReducer,
  address: addressReducer,
  contact: contactReducer,
  section: sectionReducer,
});
const store = createStore(
  appReducer,
  composeEnhancers(applyMiddleware(thunk), reduxReset(actionTypes.AUTH_LOGOUT))
);

const app = (
  <Provider store={store}>
    <HashRouter basename="/">
      <App />
    </HashRouter>
  </Provider>
);
ReactDOM.render(app, document.getElementById("app"));
unregister();



// WEBPACK FOOTER //
// ./src/index.js